import { gql } from "lib/apolloClient";

export const getOrganizationDetailsQuery = gql`
  query getOrganizationDetails($organizationId: ID!) {
    node(id: $organizationId, type: ORGANIZATION) {
      ... on Organization {
        id
        name
        logo
        loginConfig {
          id
          schoolCode
          logoUrl
          displayName
          isEnabled
          loginOptions {
            id
            type
            service
            supportedUserTypes
            metadata
          }
        }
      }
    }
  }
`;
